
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["notes",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 97.29 86.82"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"data-name":"Capa 1"}},[_c('path',{attrs:{"d":"M0 44.89V79.8h24.57l10.34-10.34V44.89zm25.45 29.78v-4.33h4.33zM3 47.89h28.91v19.45H24a1.5 1.5 0 00-1.5 1.5v8H3z"}}),_c('path',{attrs:{"d":"M8.5 53.57h17.88v3.78H8.5z"}}),_c('path',{attrs:{"fill":"none","d":"M30.99 15.65v-9.9l-9.9 9.9h9.9z"}}),_c('path',{attrs:{"d":"M24.51 38.2v4.36h35.33l-6-4.36H24.51zM33.41 48.29H68v3.37H33.41zM33.41 57.89H68v3.37H33.41zM64 29.1H24.51v3.37h37.82l-.28-.28A8.17 8.17 0 0064 29.1z"}}),_c('path',{attrs:{"d":"M95.76 11.48L89.49 5.2a5.18 5.18 0 00-7-.3l-4.3 3.6V0H32L15.33 16.64v29.55h3.37V19h15.66V3.37h40.46v8L62.22 22a1.5 1.5 0 00-.09 2.21l.7.7A7.37 7.37 0 0161 31.52a1.49 1.49 0 000 2.12l.65.65-2.93 2.91a1.51 1.51 0 00-.43 1.2 1.47 1.47 0 00.64 1.09L62.56 42a1.49 1.49 0 001.91-.17l2.36-2.36.5.5a1.45 1.45 0 001.06.44 1.48 1.48 0 001.06-.41 7 7 0 015.37-2v45.57H18.7V78.1h-3.37v8.72h63.12l-.15-47.61a1.53 1.53 0 00.71-.47l17-20.24a5.17 5.17 0 00-.25-7.02zM31 15.65h-9.9l9.9-9.9zm32.24 23.17l-1.12-.77 1.64-1.64.94.94zm5.23-2l-4.38-4.32a9.88 9.88 0 001.81-4.57l3.23 3.23.34.34L73 35.07a9.67 9.67 0 00-4.53 1.8zm25.29-20.3l-16 19-3.09-3.09-9.27-9.24 19-16a2.19 2.19 0 013 .12l6.27 6.28a2.19 2.19 0 01.09 2.98z"}})])])])
          )
        }
      }
    